import { tokens } from "@fluentui/react-components";
import { css } from "styled-components";

/**
 * Single source of truth for chat text: what the user types has to render
 * exactly like the bubble it turns into, and like the bot answers.
 */
export const chatMessageFont = css`
  font-family: ${tokens.fontFamilyBase};
  font-size: 14px;
  line-height: 20px;
`;
